import { useRef } from 'react'
import {
  Container,
  Icon,
  Row,
  Text,
  Tooltip
} from '@smuchile/pkg-unimarc-components'
import { SignUpToastProps } from './types'
import { getGlobalStyle } from '@smuchile/pkg-unimarc-components/helpers'
import { useOutside } from './helpers/useOutsideAlerter'
import { useAfterOf } from './helpers/useAfterOf'

export const SignUpToast = ({
  message,
  onClick,
  positionContainer,
  top
}: SignUpToastProps) => {
  const wrapperRef = useRef(null)

  useAfterOf({
    onFinish: onClick,
    ms: 5000
  })

  useOutside({
    onClick,
    ref: wrapperRef
  })

  return (
    <Container
      maxHeight='0px'
      zIndex='1000'
    >
      <Tooltip
        alignAllItems='center'
        background='var(--color-feedback-error-bg)'
        borderRadius={getGlobalStyle('--border-radius-2sm')}
        boxShadow='var(--box-shadow-3md)'
        closeColor='var(--color-icons-black)'
        closeIcon
        margin='8px 0 0'
        maxWidth='343px'
        onClick={onClick}
        padding='12px'
        position='fixed'
        positionContainer={positionContainer}
        right='auto'
        textComponent={
          <Container
            padding='0 12px 0 0'
            ref={wrapperRef}
          >
            <Row
              alignItems='center'
              gap='8px'
            >
              <Icon
                color='var(--color-feedback-error-light)'
                name='InfoFill'
                sizes='md'
              />

              <Text
                color='black'
                fontSize='md'
              >
                {message}
              </Text>
            </Row>
          </Container>
        }
        top={top}
        type='top'
        width='343px'
      />
    </Container>
  )
}
